import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TourPriceService', TourPriceService);

  TourPriceService.$inject = ['RestResource', '$translate', '$filter', 'UtilService'];

  function TourPriceService(RestResource, $translate, $filter, UtilService) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'tours';

    var service = {
      searchTourPrices: searchTourPrices,
      saveTourPrices: saveTourPrices,
      searchTourPickupPrices: searchTourPickupPrices,
      saveTourPickupPrices: saveTourPickupPrices,
    };

    return service;

    ////////////////

    function searchTourPrices(tour, filterCriteria) {
      var url = apiUrl + '/' + tour.id + '/tour_prices';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = tour.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTourPrices(tour, params, editMode) {
      var url = apiUrl + '/' + tour.id + '/tour_prices';

      params.company_id = tour.company_id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        var msg = !editMode ? 'PRICES_ADDED' : 'UPDATED_PRICES';
        utils._successMsg($translate(msg));

        return response.data;
      }
      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }

    function searchTourPickupPrices(tour, filterCriteria) {
      var url = apiUrl + '/' + tour.id + '/tour_pickup_prices';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = tour.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTourPickupPrices(tour, params, editMode) {
      var url = apiUrl + '/' + tour.id + '/tour_pickup_prices';

      params.company_id = tour.company_id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        var msg = !editMode ? 'PICKUP_PRICES_ADDED' : 'PICKUP_COSTS_UPDATED';
        utils._successMsg($translate(msg));

        return response.data;
      }
      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }
  }
})();
